<div class="wrapper" (click)="handleGoogleLogin()">
  <p class="msg">{{ 'SIGN.CCG' | translate }}</p>
  <div class="login-provider gmail"></div>
</div>
